export default {
  filters: {
    percentage: (value, decimals) => {
      if (!value) value = 0
      if (!decimals) decimals = 0

      value = value * 100
      return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals) + '%'
    },
    round: (value, decimals) => {
      if (!value || typeof value !== 'number') value = 0
      if (!decimals) decimals = 0
      return value.toFixed(decimals)
    }
  },
  create: function (Vue) {
    Object.keys(this.filters).forEach(function (filter, k) {
      Vue.filter(filter, this.filters[filter])
    }.bind(this))
  }
}



// WEBPACK FOOTER //
// ./src/store/filter.js